module.exports = __webpack_public_path__ + "static/media/edsvalla.767c293c.jpeg";